const moment = require('moment')
moment.locale('pt-br')

exports.stringToSlug = (str) => {
  str = str.replace(/^\s+|\s+$/g, '') // trim
  str = str.toLowerCase()

  // remove accents, swap ñ for n, etc
  const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;'
  const to = 'aaaaeeeeiiiioooouuuunc------'
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-') // collapse dashes

  return str
}

exports.dateDiff = (from, to = new Date()) => {
  return Math.round((from - to) / (1000 * 60 * 60 * 24))
}

exports.getValorAproximado = (valor) => {
  let txt = ''
  let x = Math.round(valor / 1000, 1)
  let y = valor / 1000
  let valueTxt = ''
  if (x === y) {
    valueTxt = y.toString()
  } else {
    valueTxt = x.toString()
  }

  txt = x > 0 ? valueTxt + ' Mil' : txt
  x = Math.floor((valor / 1000000) * 10) / 10
  y = valor / 1000000

  if (x === y) {
    valueTxt = y.toString()
  } else {
    valueTxt = x.toString()
  }

  txt =
    y === 1 || (y > 1 && y < 2) ? valueTxt.replace('.', ',') + ' Milhão' : txt
  txt = y >= 2 ? valueTxt.replace('.', ',') + ' Milhões' : txt

  if (y > 1000) {
    valueTxt = Math.floor((y / 1000) * 10) / 10
    txt = valueTxt.replace('.', ',') + (valueTxt > 1 ? ' Bilhões' : ' Bilhão')
  }

  if (!txt.length) {
    txt = valor.toString()
  }

  return txt
}

exports.intToReal = (number, prefix = true) => {
  const num = number.toFixed(2).split('.')
  num[0] = (prefix ? 'R$ ' : '') + num[0].split(/(?=(?:...)*$)/).join('.')
  return num.join(',')
}
exports.getClientIP = (req) => {
  return (
    req.headers['CF-Connecting-IP'] ||
    req.headers['cf-connecting-ip'] ||
    req.connection.remoteAddress
  )
}
exports.stringToColour = function (str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    colour += ('00' + value.toString(16)).substr(-2)
  }
  return colour
}

exports.getFormattedResult = (bet, gameType) => {
  let tempBet = null
  let betFormatted = null

  switch (gameType) {
    case 'tens':
      tempBet = bet.split(' - ')
      betFormatted = tempBet[0].split(' ') || []
      break
    case 'supersete':
      tempBet = bet.split(' ')
      betFormatted = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: []
      }

      tempBet.forEach((a) => {
        const b = a.split('')
        betFormatted[b[0]].push(Number(b[1]))
        betFormatted[b[0]].sort()
      })
      break
    case 'loteca':
      tempBet = {}

      bet.split('').forEach((val, index) => {
        switch (val) {
          case '1':
            tempBet[index] = { 0: false, 1: false, 2: true }
            break
          case '2':
            tempBet[index] = { 0: false, 1: true, 2: false }
            break
          case '3':
            tempBet[index] = { 0: false, 1: true, 2: true }
            break
          case '4':
            tempBet[index] = { 0: true, 1: false, 2: false }
            break
          case '5':
            tempBet[index] = { 0: true, 1: false, 2: true }
            break
          case '6':
            tempBet[index] = { 0: true, 1: true, 2: false }
            break
          case '7':
            tempBet[index] = { 0: true, 1: true, 2: true }
            break
        }
      })

      betFormatted = tempBet

      break
    case 'federal':
      betFormatted = bet.split(' ')
      break
  }

  return betFormatted
}

exports.shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]
  }

  return array
}

const stateProvinces = [
  { id: 76, uf: 'AC', name: 'Acre' },
  { id: 77, uf: 'AL', name: 'Alagoas' },
  { id: 78, uf: 'AP', name: 'Amapá' },
  { id: 79, uf: 'AM', name: 'Amazonas' },
  { id: 80, uf: 'BA', name: 'Bahia' },
  { id: 81, uf: 'CE', name: 'Ceará' },
  { id: 82, uf: 'DF', name: 'Distrito Federal' },
  { id: 83, uf: 'ES', name: 'Espirito Santo' },
  { id: 84, uf: 'GO', name: 'Goiás' },
  { id: 85, uf: 'MA', name: 'Maranhão' },
  { id: 86, uf: 'MS', name: 'Mato Grosso do Sul' },
  { id: 87, uf: 'MT', name: 'Mato Grosso' },
  { id: 88, uf: 'MG', name: 'Minas Gerais' },
  { id: 89, uf: 'PA', name: 'Pará' },
  { id: 90, uf: 'PB', name: 'Paraíba' },
  { id: 91, uf: 'PR', name: 'Paraná' },
  { id: 92, uf: 'PE', name: 'Pernambuco' },
  { id: 93, uf: 'PI', name: 'Piauí' },
  { id: 94, uf: 'RJ', name: 'Rio de Janeiro' },
  { id: 95, uf: 'RN', name: 'Rio Grande do Norte' },
  { id: 96, uf: 'RS', name: 'Rio Grande do Sul' },
  { id: 97, uf: 'RO', name: 'Rondônia' },
  { id: 98, uf: 'RR', name: 'Roraima' },
  { id: 99, uf: 'SC', name: 'Santa Catarina' },
  { id: 100, uf: 'SE', name: 'Sergipe' },
  { id: 101, uf: 'SP', name: 'São Paulo' },
  { id: 101, uf: 'TO', name: 'Tocantins' }
]

exports.getStateBy = (param, value, attr = null) => {
  if (['id', 'uf', 'name'].indexOf(param) === -1) {
    return null
  }
  if (attr && ['id', 'uf', 'name'].indexOf(attr) === -1) {
    return null
  }

  if (param === 'uf') {
    value = value.toUpperCase()
  }

  const r = stateProvinces.find((a) => a[param] === value)
  return r ? (attr ? r[attr] : r) : null
}

exports.formatDate = (date, format) => {
  return moment(date).format(format || 'DD/MM/YYYY')
}
